// Vue 3 cookie plugin using js-cookie
import Cookies from 'js-cookie'

export default {
  install(app) {
    app.config.globalProperties.$cookies = {
      get(key) {
        return Cookies.get(key)
      },
      set(key, value, options = {}) {
        // Convert expires from Date to days if needed
        if (options.expires instanceof Date) {
          const now = new Date()
          const diffTime = options.expires.getTime() - now.getTime()
          const diffDays = diffTime / (1000 * 60 * 60 * 24)
          options.expires = diffDays > 0 ? diffDays : 0
        }
        return Cookies.set(key, value, options)
      },
      remove(key, options = {}) {
        return Cookies.remove(key, options)
      }
    }
  }
}
